import { render, staticRenderFns } from "./default.vue?vue&type=template&id=07a0eae2"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/vercel/path0/components/page/Header.vue').default,PageTransitionElements: require('/vercel/path0/components/page/TransitionElements.vue').default,PageScrollTop: require('/vercel/path0/components/page/ScrollTop.vue').default,MenuOverlay: require('/vercel/path0/components/elements/MenuOverlay.vue').default,PageCookie: require('/vercel/path0/components/page/Cookie.vue').default})
